import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from './Header'
import GlobalToast from './GlobalToast'
import useTheme from '../hooks/useTheme'

const Layout: React.FC = () => {
	const theme = useTheme()

	return (
		<div
			style={{ minHeight: '100vh' }}
			data-bs-theme={theme}
			className={`${theme === 'dark' ? 'bg-dark' : 'bg-light'}`}
		>
			<Header />
			<div className="container-fluid">
				<Outlet />
			</div>
			<GlobalToast />
		</div>
	)
}

export default Layout

